import type { RouteReason } from "@/lib/api";
import { StatusDot } from "@/ui/components/status-badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/ui/components/tooltip";

const REASON: Record<RouteReason, { label: string; hint: string }> = {
  no_handler: { label: "no handler", hint: "No enabled handler for this name (default deny)." },
  handler: { label: "handler", hint: "A handler returned null." },
  error: { label: "error", hint: "A handler threw or timed out (fail-closed)." },
};

export function RouteBadge({ route, reason }: { route: string; reason?: RouteReason | null }) {
  if (route !== "drop")
    return (
      <span className="inline-flex items-center gap-1.5 text-[13px] text-positive">
        <StatusDot tone="positive" />
        pass
      </span>
    );
  const r = reason ? REASON[reason] : null;
  return (
    <span className="inline-flex items-center gap-1.5 text-[13px] text-destructive">
      {r ? (
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="text-xs text-muted-foreground">{r.label}</span>
          </TooltipTrigger>
          <TooltipContent>{r.hint}</TooltipContent>
        </Tooltip>
      ) : null}
      <StatusDot tone="destructive" />
      drop
    </span>
  );
}
